module.exports = __webpack_public_path__ + "img/facebook-icon.ec7a2d04.svg";